import http from 'utils/http';
import { getAgencyRecommendationsUrl } from './apiUrls';
import { AgencyRecommendationsListResponse } from './types';

export function getAgencyRecommendations(params?: Record<string, unknown>): Promise<AgencyRecommendationsListResponse> {
  return http.get(getAgencyRecommendationsUrl(), params);
}
